module.exports = __webpack_public_path__ + "img/headgear.4dbeeb0a.png";